// Flow 2 copy (deep intake, where, menu, itinerary, home): drafted by Astra (build/astra/flow2-final.md), gated by Claude 10/02/26.
// Do not edit strings here by hand; missing strings go in F2_PENDING below until Astra drafts them.
export const F2: Record<string, string> = {
  // place dropdown (Alvin 10/08: "drop down autopopulate"): build/astra/copy-place-autocomplete.txt, gated by Claude 10/08/26
  "place.more_heading": "Wider search",
  "place.searching": "Looking a little further…",
  "place.count_one": "1 place found",
  "place.count_other": "{count} places found",
  "place.listbox_aria": "Matching places",
  // R-52 sign-in (Google only): spec build/specs/R-52-sign-in.md rounds 1-2, round 3 build/astra/copy-signin-r3.txt
  "signin.prompt_title": "Keep this on every phone",
  "signin.prompt_body": "Sign in to keep your taste and plans with you.",
  "signin.google": "Continue with Google",
  "signin.privacy": "No password. Nothing posted anywhere. Delete your data any time.",
  "signin.later": "Not now",
  "signin.card_button": "Sign in",
  "signin.share_line": "Anyone with this link can view your plan. Sign in to keep your plans across phones and browsers.", // Astra, groups r2 (build/astra/copy-groups-r2.txt): blind test r1 read the old line as a contradiction
  "signin.settings_title": "Keep this on every phone",
  "signin.settings_sub": "Sign in with Google to keep your taste and plans with you.",
  "signin.opened_title": "You're signed in",
  "signin.opened_body": "Your taste and plans came with you.",
  "signin.merged_title": "All your plans are here",
  "signin.merged_body": "We kept the plans from this phone and your sign-in, and combined what pulls you. Nothing was deleted.",
  "signin.merged_from_phone": "From this phone",
  "signin.merged_remove": "Not mine, remove",
  "signin.merged_removed": "Removed",
  "signin.merged_done": "Done",
  "signin.working": "Finishing your sign-in...",
  "signin.slow_body": "This is taking a little longer. You can try again.",
  "signin.retry": "Try again",
  "signin.failed_title": "Sign-in didn't finish",
  "signin.failed_body": "Nothing on this phone changed. You can try again.",
  "signin.merge_failed": "You're signed in, but this phone's plans haven't come over yet. They're still here. Try again to bring them over.",
  "signin.offline": "Connect to the internet to sign in.",
  "signin.in_app_browser": "Open this page in your phone's browser to sign in with Google.",
  "settings.signed_in_as": "Signed in as {email}",
  "settings.sign_out": "Sign out",
  "settings.sign_out_title": "Sign out of this phone?",
  "settings.sign_out_body": "Nothing of yours will stay on this phone. Your taste and plans stay with your sign-in.",
  "settings.sign_out_confirm": "Sign out",
  "settings.sign_out_cancel": "Stay signed in",
  "settings.delete_signed_in": "This deletes everything of yours on every phone you're signed in on. It can't be undone.",
  "app.name": "Magellan",
  "nav.home": "Your plans",
  "nav.menu": "Menu",
  "nav.itinerary": "Itinerary",
  "nav.settings": "Settings",
  "nav.back": "Back",
  "nav.back_menu": "Back to menu",
  "common.close": "Close",
  "common.cancel": "Cancel",
  "common.apply": "Apply",
  "common.save": "Save",
  "common.edit": "Edit",
  "common.remove": "Remove",
  "common.retry": "Try again",
  "common.undo": "Undo",
  "common.skip": "Skip",
  "common.done": "Done",
  "common.clear": "Clear",
  "common.more": "More options",
  "common.continue": "Continue",
  "common.loading": "Loading",
  "common.slow": "This is taking a little longer.",
  "common.error": "That didn't work. Your changes are still here.",
  "common.offline": "You're offline. Saved plans are still available.",
  "common.offline_new": "You're offline. You can keep working on this device.",
  "common.pending": "Waiting to sync",
  "common.saving": "Saving",
  "common.saved": "Saved",
  "common.saved_device": "Saved on this device",
  "common.save_failed": "Your changes haven't synced.",
  "common.updated": "Updated {time}",
  "common.source": "Source",
  "common.details": "Details",
  "common.price_unknown": "Price not listed",
  "common.free": "Free",
  "common.per_person": "{price} per person",
  "common.time_zone": "Times shown in {timeZone}.",
  "common.check_hours": "Check hours before you go.",
  "common.location_unknown": "Location not available",
  "common.show_all": "Show all",
  "common.expand": "Expand",
  "common.collapse": "Collapse",
  "common.share_find": "Share a find",
  "common.privacy": "Privacy",
  "intake.title": "Let's make a plan",
  "intake.helper": "The more you tell us, the better your menu.",
  "intake.start": "Start with who's coming.",
  "intake.optional": "Everything else is up to you.",
  "intake.party_summary": "{party} · Change",
  "intake.go": "Go",
  "intake.topics": "Topics",
  "intake.answer": "Your answer",
  "intake.answer_placeholder": "Tell us what you have in mind.",
  "intake.tap_helper": "Choose an answer or use your own words.",
  "intake.no_preference": "No preference",
  "intake.not_sure": "Not sure yet",
  "intake.skip_topic": "Skip this topic",
  "intake.type": "Type instead",
  "intake.heard": "We heard",
  "intake.heard_empty": "Your preferences will appear here.",
  "intake.heard_count": "{count} preferences",
  "intake.heard_latest": "Added: {preference}",
  "intake.heard_updated": "Updated: {preference}",
  "intake.edit_preference": "Edit preference",
  "intake.future": "Use for future plans",
  "intake.replace": "Use {newPreference} instead of {oldPreference}?",
  "intake.replace_action": "Use this instead",
  "intake.keep_previous": "Keep the previous answer",
  "intake.privacy": "We store preferences, never medical details.",
  "intake.practical_only": "Tell us what would make the outing work for you.",
  "readiness.missing": "Still needed: {basics}",
  "readiness.ready": "Ready when you are",
  "readiness.rich": "Plenty to work with",
  "readiness.help": "You can go now or tell us more.",
  "readiness.a11y": "{count} of 18 topics covered. {availability}",
  "readiness.available": "Go is available.",
  "readiness.unavailable": "Add who, when and where to continue.",
  "voice.talk": "Talk",
  "voice.stop": "Stop recording",
  "voice.ready": "Tell us in your own words.",
  "voice.permission": "Allow microphone access to talk.",
  "voice.listening": "Listening",
  "voice.thinking": "Finding your preferences",
  "voice.no_speech": "We didn't catch any speech.",
  "voice.denied": "Microphone access is off. You can type or tap.",
  "voice.unsupported": "Voice isn't available here. You can type or tap.",
  "voice.failed": "We couldn't use that recording. Try again or type.",
  "voice.interrupted": "Recording stopped. Your preferences are still here.",
  "voice.offline": "Connect to use voice. You can still type or tap.",
  "voice.resume": "Record again",
  "voice.confirm": "Is that right?",
  "cue.who": "Who's coming, and what are they like?",
  "cue.who.hint1": "Just me, looking for a quiet day",
  "cue.who.hint2": "Two friends who love making things",
  "cue.when": "Which dates and parts of the day work?",
  "cue.when.hint1": "Saturday morning",
  "cue.when.hint2": "March 12 to 21, mostly afternoons",
  "cue.where": "Where are you starting, and how far will you explore?",
  "cue.where.hint1": "Silver Lake, within walking distance",
  "cue.where.hint2": "Based in LA, planning for Tokyo",
  "cue.occasion": "What are you planning this for?",
  "cue.occasion.hint1": "A date with something new to try",
  "cue.occasion.hint2": "Showing a friend around town",
  "cue.budget": "What would you spend per person, per day?",
  "cue.budget.hint1": "About $40 each",
  "cue.budget.hint2": "Mostly free, with one splurge",
  "cue.pace": "How much would you like to fit in?",
  "cue.pace.hint1": "One thing worth going out for",
  "cue.pace.hint2": "Two stops, with time between",
  "cue.physical": "How active do you want to be?",
  "cue.physical.hint1": "Easy walking, no heights",
  "cue.physical.hint2": "A long hike, maybe a swim",
  "cue.social": "What kind of crowd and social energy feels right?",
  "cue.social.hint1": "Small and calm, just us",
  "cue.social.hint2": "Lively, with new people to meet",
  "cue.novelty": "Would you rather try a classic or something unexpected?",
  "cue.novelty.hint1": "A local favorite we haven't tried",
  "cue.novelty.hint2": "Something strange and experimental",
  "cue.structure": "How much booking and waiting are you happy with?",
  "cue.structure.hint1": "Book ahead, skip the queues",
  "cue.structure.hint2": "Keep it spontaneous",
  "cue.rhythm": "When do you like to start and finish?",
  "cue.rhythm.hint1": "Out early, home by dinner",
  "cue.rhythm.hint2": "Start late and stay out",
  "cue.setting": "Where would you like to spend your time?",
  "cue.setting.hint1": "Outside, somewhere green",
  "cue.setting.hint2": "Indoors, right in the city",
  "cue.mode": "Would you rather join in, watch, or learn something?",
  "cue.mode.hint1": "Let me make something",
  "cue.mode.hint2": "I'd rather watch a performance",
  "cue.interests": "What could you happily spend hours getting into?",
  "cue.interests.hint1": "Old planes and odd little museums",
  "cue.interests.hint2": "Ceramics, live music and gardens",
  "cue.food_drink": "What part should food and drink play?",
  "cue.food_drink.hint1": "A quick vegetarian bite between stops",
  "cue.food_drink.hint2": "A cooking class, no alcohol",
  "cue.practical": "What practical details should we plan around?",
  "cue.practical.hint1": "Step-free places with seating",
  "cue.practical.hint2": "A child and a dog coming along",
  "cue.never": "What should we leave out completely?",
  "cue.never.hint1": "No loud clubs or big crowds",
  "cue.never.hint2": "Nothing involving heights",
  "cue.favorites": "Tell us a great day out or somewhere you've been.",
  "cue.favorites.hint1": "Loved a tiny printmaking workshop",
  "cue.favorites.hint2": "We've already done the big museums",
  "topic.who": "Who",
  "topic.when": "When",
  "topic.where": "Where",
  "topic.occasion": "Occasion",
  "topic.budget": "Budget",
  "topic.pace": "Pace",
  "topic.physical": "How active",
  "topic.social": "Social energy",
  "topic.novelty": "Familiar or new",
  "topic.structure": "Planning ahead",
  "topic.rhythm": "Time of day",
  "topic.setting": "Setting",
  "topic.mode": "Taking part",
  "topic.interests": "Interests",
  "topic.food_drink": "Food and drink",
  "topic.practical": "Practical details",
  "topic.never": "Hard no's",
  "topic.favorites": "Favorites and places tried",
  "tap.who.solo": "Just me",
  "tap.who.two": "Two of us",
  "tap.who.group": "A group",
  "tap.who.count": "How many people, including you?",
  "tap.who.count_error": "Enter at least 3 people.",
  "tap.who.partner": "My partner",
  "tap.who.friends": "Friends",
  "tap.who.family": "Family",
  "tap.who.visitors": "Visitors",
  "tap.who.coworkers": "Coworkers",
  "tap.who.children": "Children are coming",
  "tap.who.ages": "Children's age ranges",
  "tap.when.tonight": "Tonight",
  "tap.when.tomorrow": "Tomorrow",
  "tap.when.weekend": "This weekend",
  "tap.when.choose": "Choose dates",
  "tap.when.flexible": "Dates are flexible",
  "tap.when.start": "Start date",
  "tap.when.end": "End date",
  "tap.when.month": "Month",
  "tap.when.year": "Year",
  "tap.when.morning": "Morning",
  "tap.when.afternoon": "Afternoon",
  "tap.when.evening": "Evening",
  "tap.when.late": "Late night",
  "tap.when.any_time": "Any time",
  "tap.when.earliest": "Start no earlier than",
  "tap.when.latest": "Finish by",
  "tap.when.invalid": "The end date must be on or after the start date.",
  "tap.when.confirm": "Use {dateRange}?",
  "tap.where.walkable": "Walkable",
  "tap.where.near": "Near me",
  "tap.where.areas": "Parts of the city",
  "tap.where.city": "Whole city",
  "tap.where.day_trips": "Day trips",
  "tap.where.another_city": "Another city",
  "tap.where.abroad": "A trip abroad",
  "tap.transport.walk": "Walking",
  "tap.transport.bike": "Bike",
  "tap.transport.transit": "Public transit",
  "tap.transport.car": "Car",
  "tap.transport.rideshare": "Rideshare",
  "tap.budget.free": "Free",
  "tap.budget.low": "Up to $25",
  "tap.budget.mid": "$25 to $75",
  "tap.budget.high": "$75 to $150",
  "tap.budget.custom": "Set an amount",
  "tap.budget.flexible": "Flexible",
  "tap.budget.amount": "Budget per person, per day",
  "tap.budget.currency": "Currency",
  "tap.budget.one_splurge": "One splurge is fine",
  "tap.budget.help": "For activities and food, before transport or stays.",
  "tap.pace.one": "One great thing",
  "tap.pace.relaxed": "Relaxed",
  "tap.pace.relaxed_help": "About two things a day, with space between.",
  "tap.pace.packed": "Packed",
  "tap.pace.packed_help": "Plenty to do, with realistic travel time.",
  "tap.active.easy": "Take it easy",
  "tap.active.light": "A little movement",
  "tap.active.active": "Get me moving",
  "tap.active.push": "Push me",
  "tap.active.walk_label": "How long is a comfortable walk for this plan?",
  "tap.active.walk_short": "Up to 15 minutes",
  "tap.active.walk_medium": "Up to 30 minutes",
  "tap.active.walk_long": "An hour or more",
  "tap.active.thrills": "Thrills",
  "tap.active.water": "Water activities",
  "tap.active.heights": "Heights",
  "tap.preference.yes": "Yes",
  "tap.preference.no": "No",
  "tap.preference.maybe": "Maybe",
  "tap.social.calm": "Calm",
  "tap.social.lively": "Lively",
  "tap.social.small": "Small crowds",
  "tap.social.crowds_ok": "Crowds are fine",
  "tap.social.meet": "Meet new people",
  "tap.social.own_company": "Keep to our own company",
  "tap.novelty.classics": "Classics",
  "tap.novelty.experimental": "Experimental",
  "tap.novelty.famous": "Well-known places",
  "tap.novelty.hidden": "Under the radar",
  "tap.novelty.repeats": "Revisit favorites",
  "tap.novelty.new": "Somewhere new",
  "tap.structure.book": "Happy to book ahead",
  "tap.structure.spontaneous": "Keep it spontaneous",
  "tap.structure.lines": "Some waiting is fine",
  "tap.structure.no_lines": "Skip the queues",
  "tap.rhythm.early": "Early starts",
  "tap.rhythm.late": "Late nights",
  "tap.setting.indoors": "Indoors",
  "tap.setting.outdoors": "Outdoors",
  "tap.setting.nature": "Nature",
  "tap.setting.city": "City",
  "tap.mode.do": "Join in",
  "tap.mode.watch": "Watch",
  "tap.mode.learn": "Learn something",
  "tap.mode.enjoy": "Just enjoy it",
  "tap.interests.custom": "Add an interest",
  "tap.food.skip": "Leave food out",
  "tap.food.side": "A stop along the way",
  "tap.food.main": "Part of the experience",
  "tap.food.alcohol_none": "No alcohol",
  "tap.food.alcohol_optional": "Alcohol is optional",
  "tap.food.alcohol_yes": "Include drinks",
  "tap.food.preferences": "Eating preferences",
  "tap.food.adventurous": "Happy to try unfamiliar food",
  "tap.practical.kids": "Kid-friendly",
  "tap.practical.dog": "Dog-friendly",
  "tap.practical.step_free": "Step-free",
  "tap.practical.seating": "Seating available",
  "tap.never.custom": "Add a hard no",
  "tap.never.none": "Nothing to rule out",
  "tap.favorites.loved": "A day or place you loved",
  "tap.favorites.visited": "Somewhere you've already been",
  "tap.custom": "Use my own words",
  "tap.hint": "Start with this answer",
  "where.title": "Where to?",
  "where.search_label": "Where do you want to explore?",
  "where.search_placeholder": "Neighborhood, city or country",
  "where.result": "{place}, {region} · {type}",
  "where.scope": "How far would you like to explore?",
  "where.start": "Where are you starting from?",
  "where.start_placeholder": "A neighborhood or nearby landmark",
  "where.location": "Use my location",
  "where.location_help": "We'll use your area, not keep your exact location.",
  "where.transport": "How will you get around?",
  "where.travel_limit": "Maximum travel time each way",
  "where.travel_value": "About {minutes} minutes each way",
  "where.use": "Use this area",
  "where.choose_areas": "Choose areas",
  "where.start_needed": "Choose a starting area for nearby ideas.",
  "where.no_results": "We couldn't find that place.",
  "where.manual": "Enter a destination",
  "where.permission_denied": "Location access is off. Search for your area instead.",
  "where.search_failed": "We couldn't search places just now.",
  "where.year_needed": "Which year did you mean?",
  "city.unavailable_title": "We're not in {city} yet.",
  "city.unavailable_body": "We saved your trip. We'll tell you here when it's ready.",
  "city.coverage": "For now, our activity menu covers Los Angeles.",
  "city.plan_la": "Plan something in LA",
  "city.view_saved": "View saved trip",
  "city.saving": "Saving your trip",
  "city.save_failed": "Your trip hasn't saved yet.",
  "city.pending": "Destination request pending",
  "city.saved_status": "Saved for {city}",
  "city.not_ready": "Activity menu not available yet",
  "city.ready_action": "View menu",
  "portrait.title": "This sounds like you",
  "portrait.helper": "A few things we'll keep in mind. Change anything.",
  "portrait.agree": "That fits",
  "portrait.change": "Change",
  "portrait.evidence": "What this is based on",
  "portrait.correction": "What would fit better?",
  "portrait.apply": "Update this",
  "portrait.menu": "See my menu",
  "portrait.skip": "Skip this",
  "portrait.refine": "Fine-tune with a few picks",
  "portrait.limited": "We have a starting point. You can tell us more anytime.",
  "portrait.error": "We couldn't put this together. Your menu is still available.",
  "portrait.evidence_answer": "Based on your answer about {topic}.",
  "portrait.evidence_rating": "Based on how you rated {activity}.",
  "deck.title": "Which would you choose?",
  "deck.helper": "Swipe or tap to rate each idea.",
  "deck.position": "{current} of {total}",
  "deck.no": "No",
  "deck.meh": "Meh",
  "deck.like": "Like",
  "deck.love": "Love",
  "deck.finish": "That's enough for now",
  "deck.skip": "Skip to my menu",
  "deck.learning": "What we're learning",
  "deck.empty": "We don't have more ideas to rate right now.",
  "deck.continue": "Continue with what we know",
  "menu.title": "Your menu",
  "menu.context": "{place} · {dateRange}",
  "menu.helper": "Add what you like. Your plan takes shape as you go.",
  "menu.ask": "Ask for something",
  "menu.ask_placeholder": "Free and outdoors Saturday morning",
  "menu.ask_submit": "Find ideas",
  "menu.ask_voice": "Ask by voice",
  "menu.ask_applied": "Showing {summary}.",
  "menu.ask_confirm": "Show {summary}?",
  "menu.ask_error": "We couldn't use that request. Your menu is unchanged.",
  "menu.list": "List",
  "menu.map": "Map",
  "menu.any_day": "Any day",
  "menu.any_day_help": "Choose a day when you add it. Opening hours vary.",
  "menu.day": "{weekday}, {date}",
  "menu.add": "Add",
  "menu.added": "Added",
  "menu.not_for_me": "Not for me",
  "menu.more_like": "More like this",
  "menu.similar": "Like {activity}",
  "menu.why": "Why it fits",
  "menu.view_item": "View in plan",
  "menu.remove_item": "Remove from plan",
  "menu.choose_occurrence": "Choose a time",
  "menu.choose_day": "Add to which day?",
  "menu.unscheduled": "Keep unscheduled",
  "menu.add_confirmation": "{activity} added to your plan.",
  "menu.add_failed": "This hasn't synced to your plan yet.",
  "menu.feedback": "What didn't fit?",
  "menu.feedback_optional": "Optional. This helps with this menu.",
  "menu.reason.taste": "Not my thing",
  "menu.reason.price": "Too expensive",
  "menu.reason.distance": "Too far",
  "menu.reason.time": "Wrong time",
  "menu.dismissed": "Set aside for this plan",
  "menu.filter.free": "Free",
  "menu.filter.outdoors": "Outdoors",
  "menu.filter.calm": "Low-key",
  "menu.filter.active": "Active",
  "menu.filter.hidden": "Under the radar",
  "menu.filter.more": "More filters",
  "menu.filter.clear": "Clear filters",
  "menu.filter.remove": "Remove {filter} filter",
  "menu.empty": "Nothing matches these filters yet.",
  "menu.empty_help": "Try clearing a filter or choosing another day.",
  "menu.dates_empty": "We don't have activities for those dates yet.",
  "menu.change_dates": "Change dates",
  // B-031 dates editable (Astra, 10/02/26, build/astra/copy-dates-lines.txt)
  "plan.remove_dates": "Remove dates",
  "plan.moved_any_day_one": "One thing moved to Any day",
  "plan.moved_any_day": "{count} things moved to Any day",
  "menu.refresh_failed": "We couldn't update your menu. Your previous ideas are still here.",
  "menu.all_added": "These ideas are all in your plan.",
  "menu.keep_browsing": "Keep exploring",
  "menu.changed": "Details have changed. Review before adding.",
  "menu.unavailable": "This activity is no longer available.",
  "map.search_area": "Search this area",
  "map.schematic": "Connections shown, not directions.",
  "map.start": "Starting area: {area}",
  "map.pin": "{number}: {activity}",
  "map.cluster": "{count} activities in this area",
  "map.zoom_in": "Zoom in",
  "map.zoom_out": "Zoom out",
  "map.failed": "The map couldn't load. Your list is still available.",
  "tray.title": "Your plan",
  "tray.empty": "Add your first activity.",
  "tray.count": "{count} activities",
  "tray.view": "View plan",
  "tray.unscheduled": "Day to choose",
  "category.art": "Art",
  "category.film": "Film",
  "category.music": "Music",
  "category.food": "Food",
  "category.drink": "Drinks",
  "category.comedy": "Comedy",
  "category.talks": "Talks",
  "category.outdoors": "Outdoors",
  "category.fitness": "Fitness",
  "category.market": "Markets",
  "category.class": "Classes",
  "category.nightlife": "Nightlife",
  "category.community": "Community",
  "category.theater": "Theater",
  "category.day_trip": "Day trips",
  "category.other": "Other activities",
  "badge.hidden": "Under the radar",
  "itin.title": "Your itinerary",
  "itin.name": "Plan name",
  "itin.default_name": "{place}, {dateRange}",
  "itin.add": "Add something",
  "itin.empty": "Start with one thing you'd like to do.",
  "itin.empty_action": "Explore your menu",
  "itin.day_empty": "A little room to explore.",
  "itin.day_empty_action": "Browse this day",
  "itin.flexible_empty": "Choose dates when you're ready to build your days.",
  "itin.choose_dates": "Choose dates",
  "itin.choose_day": "Choose day",
  "itin.previous_day": "Previous day",
  "itin.next_day": "Next day",
  "itin.day_count": "{date} · {count} activities",
  "itin.day_count_one": "{date} · 1 activity",
  "itin.unscheduled": "Unscheduled",
  "itin.time_to_choose": "Time to choose",
  "itin.set_time": "Set time",
  "itin.change_time": "Change time",
  "itin.start_time": "Start time",
  "itin.end_time": "End time",
  "itin.duration": "Duration",
  "itin.suggested_duration": "Suggested duration: {duration}",
  "itin.next_date": "Ends {date} at {time}",
  "itin.move": "Move",
  "itin.move_up": "Move up",
  "itin.move_down": "Move down",
  "itin.move_day": "Move to day",
  "itin.drag": "Move {activity}",
  "itin.moved": "Moved {activity} to {position} on {date}.",
  "itin.preview_changes": "Review time changes",
  "itin.apply_changes": "Apply changes",
  "itin.fixed_time": "This event has a fixed time.",
  "itin.no_occurrence": "This event isn't available on {date}.",
  "itin.travel_walk": "About {minutes} min walk",
  "itin.travel_drive": "About {minutes} min drive",
  "itin.travel_transit": "About {minutes} min by transit",
  "itin.travel_bike": "About {minutes} min by bike",
  "itin.travel_rideshare": "About {minutes} min by rideshare",
  "itin.travel_loading": "Checking travel time",
  "itin.travel_unknown": "Travel time isn't available.",
  "itin.travel_mode": "Choose how you'll get there",
  "itin.conflict_overlap": "These activities overlap by {minutes} minutes.",
  "itin.conflict_travel": "This leaves {gap} minutes for about {travel} minutes of travel.",
  "itin.conflict_closed": "This place closes before your visit ends.",
  "itin.conflict_hours": "We haven't confirmed the hours for this time.",
  "itin.review_conflict": "Review times",
  "itin.choose_another": "Choose another activity",
  "itin.keep_unscheduled": "Keep unscheduled",
  "itin.tentative": "Tentative time",
  "itin.fill_evening": "Fill this evening",
  "itin.dinner_before": "Dinner before",
  "itin.something_after": "Something after",
  "itin.before": "Before",
  "itin.after": "After",
  "itin.calmer": "Calmer",
  "itin.closer": "Closer",
  "itin.cheaper": "Cheaper",
  "itin.swap": "Swap",
  "itin.other_options": "Other options ({count})",
  "itin.preview_evening": "See how it fits",
  "itin.add_evening": "Add to plan",
  "itin.no_evening_options": "We haven't found a good fit for this gap.",
  "itin.no_evening_help": "Keep the space open or browse your menu.",
  "itin.route": "Route for {date}",
  "itin.remove_confirmation": "Removed {activity} from your plan.",
  "calendar.add": "Add to calendar",
  "calendar.review": "Review your calendar export",
  "calendar.included": "{count} timed activities",
  "calendar.unscheduled": "{count} activities still need a time.",
  "calendar.set_times": "Set times",
  "calendar.conflicts": "Some times need a look before you export.",
  "calendar.review_times": "Review times",
  "calendar.export_anyway": "Export these times anyway",
  "calendar.apple": "Apple Calendar",
  "calendar.google": "Google Calendar",
  "calendar.file": "Download calendar file",
  "calendar.apple_help": "Open the file in Apple Calendar to add your plan.",
  "calendar.google_help": "Import the file into Google Calendar on a computer.",
  "calendar.preparing": "Preparing your calendar file",
  "calendar.downloaded": "Calendar file downloaded.",
  "calendar.handoff": "Finish adding your plan in your calendar.",
  "calendar.failed": "We couldn't prepare the calendar file.",
  "calendar.no_timed": "Choose a time for at least one activity first.",
  "calendar.update_needed": "Your calendar copy needs updating.",
  "calendar.no_sync": "Later changes here won't update your calendar automatically.",
  "calendar.repeat": "You've exported this plan before. Importing again may create duplicates.",
  "calendar.download_again": "Download again",
  "share.title": "Share your plan",
  "share.view_only": "Share a view-only link",
  "share.view_help": "Anyone with the link can see this plan, but can't change it.",
  "share.copy": "Copy link",
  "share.device": "Share link",
  "share.copied": "Link copied",
  "share.copy_failed": "We couldn't copy the link.",
  "share.create_failed": "We couldn't create the link.",
  "share.off": "Turn off link sharing",
  "share.off_confirm": "Turn off this link?",
  "share.off_body": "People with the link will no longer be able to open this plan.",
  "share.revoked": "This plan is no longer shared.",
  "share.read_only": "View-only plan",
  "share.private": "Your private preferences aren't included.",
  "partner.invite": "Plan with my partner",
  "partner.disclosure": "You'll both be able to change this plan and see each other's votes.",
  "partner.private": "Your intake answers stay private.",
  "partner.join": "Join this plan",
  "partner.invite_copy": "Copy partner invite",
  "partner.waiting": "Waiting for your partner to join",
  "partner.joined": "{name} joined the plan.",
  "partner.yes": "Yes",
  "partner.no": "Not this time",
  "partner.both_yes": "You both said yes",
  "partner.said_yes": "{name} said yes.",
  "partner.said_no": "{name} said not this time.",
  "partner.no_vote": "No vote yet",
  "partner.change": "{name} changed {activity}.",
  "partner.review": "Review change",
  "partner.collision": "You both changed this item. Choose what to keep.",
  "partner.keep_mine": "Keep my change",
  "partner.keep_theirs": "Keep {name}'s change",
  "partner.disconnected": "Shared updates will resume when you reconnect.",
  "partner.link_invalid": "This partner invite is no longer available.",
  "home.title": "Your plans",
  "home.new": "Start a new plan",
  "home.upcoming": "Upcoming",
  "home.past": "Past",
  "home.open": "Open plan",
  "home.plan_count": "{count} activities planned",
  "home.plan_count_one": "1 activity planned",
  "home.next": "Next: {activity} · {dateTime}",
  "home.empty": "Your next outing starts here.",
  "home.empty_help": "Choose who, when and where. We'll help with the rest.",
  "home.no_upcoming": "Nothing coming up yet.",
  "home.no_past": "Your past plans will appear here.",
  "home.weekly": "New for you this week",
  "home.weekly_more": "See this week",
  "home.weekly_empty": "No new finds for you just yet.",
  "home.weekly_failed": "We couldn't load this week's finds. Your plans are still here.",
  "home.new_title": "What's the next plan?",
  "home.known": "We'll use the preferences you've already shared.",
  "home.edit_preferences": "Edit preferences",
  "home.tell_more": "Tell us more",
  "home.create": "Find activities",
  "home.choose_plan": "Which plan should this go in?",
  "home.create_for_item": "Start a plan with this",
  "home.flexible_dates": "Dates flexible · {dateWindow}",
  "cue.about": "If you like: age range, gender, local or visiting.",
  "cue.about.hint1": "In my 30s, a woman, living in LA.",
  "cue.about.hint2": "Visiting for the weekend.",
  "seeit.label": "Explore this place",
  "seeit.tiktok": "TikTok",
  "seeit.instagram": "Instagram",
  "seeit.reddit": "Reddit",
  "seeit.youtube": "YouTube",
  "seeit.maps": "Google Maps",
  "scout.looking": "Checking nearby venues' calendars.",
  "scout.found": "New on your menu: {N}",
  "plan.build_for_me": "Draft my plan",
  "plan.use_this": "Use this plan",
  "plan.draft_title": "Your plan to make yours",
  "topic.about": "About you",
  "tap.about.age": "Age range",
  "tap.about.gender": "Gender",
  "tap.about.local": "I live here",
  "tap.about.new": "New in town",
  "tap.about.visiting": "Visiting",
  "seeit.aria": "Find {name} on {site}",
  "menu.suggested": "Suggested time: {time}",
  "tray.count_one": "1 activity",
  "calendar.included_one": "1 scheduled activity",
  "calendar.unscheduled_one": "1 activity still needs a time.",
  "badge.new": "Just found",
  "build.helper": "A day-by-day draft based on your taste. Remove anything you don't want.",
  "build.loading": "Drafting your plan",
  "build.empty": "We couldn't find activities that fit these dates.",
  "build.skipped": "No activities fit on {days}.",
  "build.failed": "We couldn't save your plan. Try again.",
  "build.why.fit": "Fits your taste",
  "build.why.loved": "You loved this",
  "build.why.passion": "Matches what you love",
  "build.why.nearby": "Near your previous stop",
  "common.length_min": "~{minutes} min",
  "common.length_hr": "~{hours} hr",
  "menu.window": "Open {hours}",
  "menu.visit": "your visit {time}",
  "menu.back_to_top": "Back to top",
  "menu.loose": "No exact matches. These come closest.",
  "menu.reason.kids": "Not for kids",
  "menu.reason.long": "Too long",
  "menu.reason.crowded": "Too crowded",
  "itin.travel_ride": "About {minutes} min by rideshare",
  "itin.travel_any": "About {minutes} min to get there",
  "itin.visit_length": "How long you'll stay",
  "itin.window_outside": "Keep your visit between {open} and {close}.",
  "calendar.suggested": "Suggested time",
  "build.existing": "Already in your plan",
  "build.day_empty": "Nothing new to add for this day.",
  "build.nothing_new": "Everything here is already in your plan.",
  "intake.heard_playback": "Got it: {preferences}",
  "intake.who_cue": "Tell us who's coming",
  "heard.kids": "Kids' ages: {ages}",
  "heard.from": "from {hour}",
  "heard.until": "until {hour}",
  "heard.occasion.date": "A date",
  "heard.occasion.solo": "Time on my own",
  "heard.occasion.friends": "With friends",
  "heard.occasion.new": "Something new",
  "heard.occasion.meet": "Meeting people",
  "heard.occasion.celebrate": "A celebration",
  "heard.occasion.visitors": "Showing visitors around",
  "heard.occasion.family": "Family time",
  "heard.food.main": "Food as part of the plan",
  "heard.food.side": "A food stop",
  "heard.food.skip": "No food stops",
  "heard.about.local": "You live here",
  "heard.about.new": "New in town",
  "heard.about.visiting": "Visiting",
  "tap.who.kids_ages": "Kids' ages, if any",
  "tap.who.kids_ages_help": "For example: 6, 9",
  "share.press_hold": "Press and hold the link to copy it.",
  "where.near_area": "{place} · near {area}",
  "err.after_close": "This place closes before your visit starts. Choose an earlier time.",
  "err.outside_window": "Your visit needs to fit within the event's hours.",
  "err.not_on_dates": "This isn't available on your plan's dates.",
  "menu.ask_none": "No matches this time. Your menu is unchanged.",
  "menu.added_for": "Added for {time}",
  "menu.day_nothing": "Nothing planned yet",
  "share.copy_keys": "On a computer, press Ctrl+C (Cmd+C on a Mac). On a phone, touch and hold the link, then tap Copy.",
  "calendar.time_to_set": "No time set yet",
  "build.saving": "Saving your plan",
  "build.removed": "Removed",
  "menu.distance_from": "{MI} mi from {place}",
  "menu.matches": "Matches: {list}",
  "menu.seated": "Seated",
  "menu.on_feet": "On your feet",
  "calendar.title_dinner": "Dinner at {venue}",
  "calendar.title_lunch": "Lunch at {venue}",
  "calendar.title_brunch": "Brunch at {venue}",
  "tap.who.older": "Parents or grandparents coming",
  "intake.who_done": "Who's coming",
  "tap.when.week": "This week",
  "tap.when.weeknights_weekend": "Weeknights after work and weekends",
  "heard.weeknights_from": "Weeknights from {hour}",
  "itin.tight_no_gap": "Tight: {travel} min travel, no time between activities",
  "itin.tight_gap": "Tight: {travel} min travel, {gap} min between activities",
  "itin.fix_it": "Fix it",
  "itin.fix_none": "No free time that day. Try Change time.",
  "menu.ask_placeholder_short": "Try \"free and outdoors\"",
  "intake.privacy2": "We only keep what helps plan your outings. You can skip anything.",
  // R8 (Astra, gated)
  "menu.top": "Your top picks",
  "menu.top_help": "Your best matches, based on what you shared.",
  "menu.any_day_help_one": "Add to your day. Opening hours vary.",
  "intake.type_submit": "Send",
  "intake.go_wait": "Putting your picks together.",
  "portrait.you_said": "You said: {text}",
  "tune.loading": "Getting your first card ready.",
  "calendar.google_phone": "Add each stop to Google Calendar using its own Add button.",
  "calendar.apple_phone": "Opens your calendar with all stops ready to add.",
  "calendar.open": "Open in Calendar",
  "move.no_free_time": "We couldn't find free time that day. Choose a time yourself.",
  // R8b (Astra, gated): labels CategoryLabel looks for (build/astra/copy-r8b-final.json)
  "tag.history": "History",
  "tag.games": "Games",
  "tag.animals": "Animals",
  "tag.science": "Science",
  "tag.machines": "Transportation",
  "tag.sports": "Sports",
  // WP13 (Astra, gated): one-door landing (build/astra/copy-landing2-final.json) and a city on demand (copy-r8fix-final.json city.*)
  "landing.headline": "Your kind of day, planned",
  "landing.sub": "Get a menu of small happenings and places worth visiting, then build a plan from the ones you like.",
  "landing.button": "Make my plan",
  "landing.note": "Free. No account needed.",
  "landing.step1": "Tell us what you like",
  "landing.step1_sub": "Talk or type about who's going, when, where, and what you enjoy.",
  "landing.step2": "Choose from your menu",
  "landing.step2_sub": "Add what interests you. Skip what doesn't.",
  "landing.step3": "See your days take shape",
  "landing.step3_sub": "Get a day-by-day plan to save, share, or add to your calendar.",
  "landing.cities": "Los Angeles is ready. Other cities take about a minute when you ask.",
  "city.building_title": "Getting {city} ready",
  "city.building_body": "We're gathering places worth your time. This takes about a minute.",
  "city.ready": "{city} is ready",
  "city.failed": "We couldn't get this city ready. Please try again.",
  "city.need_city": "Which city in {place} would you like to explore?",
  "city.limited": "Well-known places and local favorites for now. Small, one-off events will come later.",
  // WP16 (Astra, gated): browse first (build/astra/copy-flow3-final.json). tray.empty is stored as tray.plan_empty:
  // the key already holds Flow 2's tray wording, which the old plan menu still uses.
  "browse.headline": "Find something worth going out for",
  "browse.sub": "Explore Los Angeles, follow an interest, and put a plan together.",
  "browse.sub_city": "Explore {city}, follow an interest, and put a plan together.",
  "browse.categories": "Explore by category",
  "browse.category_count_one": "1 thing to do",
  "browse.category_count_other": "{count} things to do",
  "browse.weekend": "This weekend",
  "browse.near": "Near you",
  "browse.free": "Free to explore",
  "browse.radar": "Under the radar",
  "browse.classes": "Classes to try",
  "browse.people": "Things to do with others",
  "browse.all": "All things to do",
  "browse.see_all": "See all",
  "browse.see_all_label": "See all: {row}",
  "browse.previous": "Previous",
  "browse.next": "Next",
  "browse.more": "Show more",
  "browse.results_one": "1 thing to do",
  "browse.results_other": "{count} things to do",
  "browse.empty_title": "Nothing matches just yet",
  "browse.empty_body": "Try a wider area or fewer filters.",
  "browse.category_empty": "There's nothing in this category yet.",
  "browse.city_empty_title": "We haven't explored {city} yet",
  "browse.city_empty_body": "Request this city to help us decide where to explore next.",
  "browse.city_request": "Request this city",
  "browse.city_requested": "City requested",
  "browse.city_request_failed": "Could not request this city. Try again.",
  "browse.back_la": "Browse Los Angeles",
  "browse.loading": "Finding things to do…",
  "browse.slow": "This is taking a little longer.",
  "browse.error": "Could not load these listings. Try again.",
  "browse.offline": "You're offline. Showing what's available on this device.",
  "browse.retry": "Retry",
  "browse.yours_title": "Make it yours",
  "browse.yours_body": "Tell us what you enjoy. We'll bring more of it to the top.",
  "browse.yours_action": "Tell us a little",
  "browse.cue_interest": "Something I could spend hours doing",
  "browse.cue_try": "Something I'd like to try",
  "browse.cue_day": "My kind of day out",
  "browse.show_matches": "Show my matches",
  "filter.where": "Where",
  "filter.where_placeholder": "Zip, postal code, neighborhood or city",
  "filter.where_helper": "Choose an area to explore nearby.",
  "filter.use_location": "Use my location",
  "filter.current_location": "Your location",
  "filter.location_denied": "Location isn't available. Enter an area instead.",
  "filter.location_empty": "No matching area. Try a city or postal code.",
  "filter.location_error": "Could not find that area. Try again.",
  "filter.distance": "Distance",
  "filter.distance_any": "Any distance",
  "filter.distance_value": "Within {miles} mi",
  "filter.distance_helper": "Approximate distance in a straight line from {area}.",
  "filter.when": "When",
  "filter.any_time": "Any time",
  "filter.today": "Today",
  "filter.tomorrow": "Tomorrow",
  "filter.weekend": "This weekend",
  "filter.choose_dates": "Choose dates",
  "filter.start_date": "Start date",
  "filter.end_date": "End date, optional",
  "filter.apply_dates": "Use these dates",
  "filter.date_error": "Choose an end date on or after the start date.",
  "filter.category": "Category",
  "filter.all_categories": "All categories",
  "filter.free": "Free",
  "filter.radar": "Under the radar",
  "filter.setting": "Setting",
  "filter.any_setting": "Any setting",
  "filter.indoors": "Indoors",
  "filter.outdoors": "Outdoors",
  "filter.open": "Filters",
  "filter.additional_one": "1 more filter",
  "filter.additional_other": "{count} more filters",
  "filter.edit": "Edit filters",
  "filter.reset": "Reset",
  "filter.results": "Show results",
  "filter.close": "Close filters",
  "listing.add": "Add to plan",
  "listing.adding": "Adding…",
  "listing.added": "In your plan",
  "listing.add_error": "Could not add this. Try again.",
  "listing.retry": "Retry",
  "listing.set_aside": "Set aside",
  "listing.undo": "Undo",
  "listing.remove": "Remove from plan",
  "listing.regular_hours": "Regular hours",
  "listing.check_hours": "Check opening hours",
  "listing.price_unknown": "Price not listed",
  "listing.free": "Free",
  "listing.distance": "About {miles} mi away",
  "listing.timezone": "Times shown in {timezone}",
  "listing.radar": "Under the radar",
  "listing.see_it": "See it",
  "listing.tiktok": "TikTok",
  "listing.instagram": "Instagram",
  "listing.reddit": "Reddit",
  "listing.youtube": "YouTube",
  "listing.maps": "Google Maps",
  "listing.external_label": "Open {title} on {destination} in a new tab",
  "listing.source": "Source: {source}",
  "listing.checked": "Checked {date}",
  "listing.source_unavailable": "Source link unavailable",
  "listing.canceled": "This event was canceled",
  "listing.ended": "This event has ended",
  "listing.unavailable": "This listing is no longer available",
  "listing.close": "Close details",
  "listing.calendar": "Add to calendar",
  "listing.calendar_handoff": "Calendar opened",
  "tray.saving": "Saving…",
  "tray.one": "1 thing in your plan",
  "tray.other": "{count} things in your plan",
  "tray.pending": "Waiting for connection",
  "tray.error": "Could not save your plan",
  "tray.retry": "Retry",
  "tray.plan_empty": "Plan is empty",
  "tray.undo": "Undo",
  "plan.title": "Your plan",
  "plan.no_dates": "No dates set",
  "plan.no_dates_body": "Keep a few ideas here. Choose dates whenever you're ready.",
  "plan.set_dates": "Set dates",
  "plan.draft_days": "Draft the days",
  "plan.draft_dates_body": "Choose dates so we can arrange your picks into days.",
  "plan.add_people": "Add people",
  "plan.share": "Share",
  "plan.share_body": "Anyone with this link can view your plan.",
  "plan.copy_link": "Copy link",
  "plan.link_copied": "Link copied",
  "plan.share_error": "Could not create a link. Try again.",
  "plan.cancel": "Cancel",
  "plan.move_up": "Move up",
  "plan.move_down": "Move down",
  "plan.set_aside": "Set aside",
  "plan.set_aside_body": "Things you've kept for another time.",
  "plan.set_aside_empty": "Nothing set aside yet",
  "plan.empty_title": "Your plan starts with one thing",
  "plan.empty_body": "Browse and add something you'd like to do. Dates can wait.",
  "plan.browse": "Browse things to do",
  "nav.brand": "Magellan",
  "nav.browse": "Browse",
  "nav.plan": "Plan",
  "nav.back_browse": "Back to Browse",
  // flow 3b (build/astra/copy-flow3b-final.json), 10/02/26
  "browse.for_you": "For you",
  // fr3 (Astra, build/astra/copy-fr3.txt, gated 10/08): Browse as a For you feed after first run
  "home.for_you_title": "Picked for you",
  "home.because": "You picked {interest}",
  "home.welcome": "A place to start, shaped by what you told us.",
  "home.near_chip": "Within {distance} of {place}",
  "home.near_change": "Change",
  "home.explore_title": "Explore more activities",
  // fr4 (Astra, build/astra/copy-fr4-final.json, gated 10/08): the live home-area count in the first run
  "onb.area_progress": "Finding activities near {home}: {count} so far",
  "onb.area_ready": "{count} activities near {home} to explore",
  "tray.consent": "By adding, you confirm you're 18 or older, agree to the Terms, and acknowledge the Privacy page.",
  "yours.title": "What do you enjoy?",
  "yours.sub": "A few sentences are enough to bring more of what you like to the top.",
  "yours.who_prompt": "Who do you usually go out with?",
  "yours.helper": "Share as much or as little as you like.",
  "yours.continue_sr": "Return to listings without sharing anything.",
  "yours.done": "Back to listings",
  "plan.left_title": "Still in your list",
  "plan.left_body": "These didn't fit your dates but stay listed. Set a time yourself or choose other dates.",
  "plan.add_other_dates": "This event is outside your dates. We started a new plan for it.",
  // "What do you enjoy?" finish button (build/astra/copy-yours-done.txt, pick_listings), 10/02/26: shown once they said
  // something; with nothing said the button keeps "yours.done" (Astra's no_share_listings, the same words)
  "yours.done_saved": "Save and browse listings",
  "onb.cat.music": "Live music",
  "onb.cat.outdoors": "Outdoors and hikes",
  "onb.cat.theater": "Theater",
  "onb.cat.art": "Art and galleries",
  "onb.cat.comedy": "Comedy",
  "onb.cat.market": "Markets",
  "onb.cat.food": "Food outings",
  "onb.cat.film": "Film",
  "onb.cat.fitness": "Fitness",
  "onb.cat.nightlife": "Nightlife",
  "onb.cat.class": "Classes and workshops",
  "onb.cat.community": "Community and meetups",
  "onb.cat.talks": "Talks and ideas",
  "onb.cat.career": "Career and startups",
  "onb.cat.day_trip": "Day trips",
  "onb.cat.history": "History",
  "onb.cat.games": "Games",
  "onb.cat.books": "Books",
  "onb.cat.dance": "Dance",
  "onb.cat.science": "Science and tech",
  "onb.cat.design": "Design",
  "onb.cat.photography": "Photography",
  "onb.cat.wellness": "Wellness",
  "onb.cat.sports": "Sports",
  "onb.interests_title": "What pulls you?",
  "onb.interests_help": "Pick at least 3 interests across these screens. Go with what sounds like you.",
  // fr2 (Astra, build/astra/copy-fr2.txt, gated 10/08): per-screen interest headlines, voice-note result
  "onb.interests_title_1": "What sounds like you?",
  "onb.interests_help_1": "Pick at least 3 interests in total across these three screens.",
  "onb.interests_title_2": "Anything else you love?",
  "onb.interests_help_2": "Pick any others you like, or leave this screen blank.",
  "onb.interests_title_3": "One last look",
  "onb.interests_help_3": "Anything more to add? Your picks across all three screens count.",
  "onb.heard_added": "Added: {list}",
  "onb.need_more": "Pick {count} more to help us get started",
  "onb.need_more_one": "Pick 1 more to help us get started",
  "onb.picked": "{count} picked",
  "onb.talk": "Hold to share your interests",
  "onb.type_label": "Type a few things you're into",
  "onb.talk_help": "Or tap to type",
  "onb.type_placeholder": "What else are you into?",
  "onb.type_send": "Add",
  "onb.heard_matched": "Picked from what you shared: {list}",
  "onb.heard_none": "We kept your note, but couldn't match it to an interest.",
  // fr5 (Astra, build/astra/copy-fr5-final.json, gated 10/08): chips that accrue; unmatched words are kept
  "onb.heard_kept_label": "Also kept:",
  "onb.heard_kept_help": "We’ll use these for your picks, even without matching tiles.",
  "onb.chip_remove_sr": "Remove {name}",
  "onb.next": "Next",
  "onb.home_title": "Where's home?",
  "onb.home_help": "Enter an address, city, zip or postal code. Your plans start here unless you choose somewhere else.",
  "onb.home_find": "Find",
  "onb.home_finding": "Finding the spot",
  "onb.home_not_found": "Couldn't find that spot. Try a city, zip or postal code.",
  "onb.home_skip": "Skip for now",
  "onb.pace_help": "Pick any that fit",
  "onb.done_title": "You're all set",
  "onb.done_help": "We'll use these to find activities you'll like. You can change them in settings.",
  "onb.sum_interests": "Your interests",
  "onb.sum_home": "Home area",
  "onb.sum_pace": "Your pace",
  "onb.sum_home_none": "Not set yet",
  "onb.see": "See my activities",
  "onb.heard": "How did you hear about us?",
  "onb.heard.friend": "A friend",
  "onb.heard.instagram": "Instagram",
  "onb.heard.tiktok": "TikTok",
  "onb.heard.search": "Search",
  "onb.heard.other": "Somewhere else",
  "onb.save_failed": "That didn't save. Try again.",
  "plan.create": "Create a plan",
  "cp.where_title": "Where do you want to explore?",
  "cp.where_help": "Start near home or choose somewhere you're visiting.",
  "cp.home_label": "Home \u00b7 {place}",
  "cp.change": "Change",
  "cp.how_far": "How far?",
  "cp.within": "Within {miles} mi",
  "cp.anywhere": "Any distance",
  "cp.min": "1 mi",
  "cp.usual": "Your usual",
  "cp.more_title": "Anything else for this plan?",
  "cp.optional": "Optional",
  "cp.more_why": "This helps us find activities that fit this plan.",
  "cp.topics": "What sounds good?",
  "cp.talk": "Hold to talk, or type what you have in mind",
  "cp.make": "Make my plan",
  "cp.making": "Getting your picks ready",
  "browse.picked": "Picked for this plan",
  "browse.picked_clear": "Show everything",
  "browse.widen": "Look farther out",
  "browse.clear_filters": "Clear filters",
  "plans.draft": "Draft",
  "plans.draft_help": "Tap Add on an activity to put it here.",
  "plans.empty_body": "Find an activity you like and tap Add. It'll go in your draft plan.",
  "plans.browse": "Browse activities",
  "plans.failed": "Couldn't load your plans. Try again.",
  "plan.item_canceled": "Canceled",
  "plan.item_past": "Already happened",
  "shared.make_own": "Make your own",
  "shared.make_own_line": "Into this? Share your interests to find activities near you.",
  "found.door_title": "Know something good?",
  "found.door_body": "Share a link to an event or a place worth exploring.",
  "found.door_action": "Share a find",
  "settings.retake": "Update your preferences",
  "listing.rsvp_approval": "Host approval needed",
  "listing.rsvp_host": "Ask to join on the host's page",
  "listing.address_after_rsvp": "Address shared after you RSVP",
  // QA prod r1 (10/08/26): drafted by Astra (copy lane), gated by Claude
  "listing.on_now_through": "On now · Through {day}",
  "listing.on_now_until": "On now · Until {time}",
  "onb.home_finding_place": "Finding {place}…",
  "onb.picked_of_min": "{count} of {min} picked",
}

// ASTRA-PENDING: temporary strings waiting for Astra's draft.
export const F2_PENDING: Record<string, string> = {
}

/** True when the copy file has wording for this key (approved or pending). */
export const hasF2 = (key: string): boolean => key in F2 || key in F2_PENDING

export function f2(key: string, vars?: Record<string, string | number>): string {
  let s = F2[key] ?? F2_PENDING[key] ?? key
  if (vars) for (const [k, v] of Object.entries(vars)) s = s.replaceAll(`{${k}}`, String(v))
  return s
}
